import { makeStyles } from '@material-ui/styles';
import {
    grayColor,
    roseColor,
    primaryColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
} from '../material-kit-pro-react';
import * as colors from '../../../constants/Colors';
import { linkPrimaryColor, primaryFontFamily } from '../../../constants/StyleConfig';

export default makeStyles((theme) => ({
    button: {
        minHeight: 'auto',
        minWidth: 'auto',
        backgroundColor: grayColor,
        color: colors.white,
        borderRadius: 3,
        boxShadow: 'none',
        border: 'none',
        position: 'relative',
        padding: '12px 30px',
        margin: '.3125rem 0px',
        fontSize: '15px',
        fontWeight: 600,
        fontFamily: primaryFontFamily,
        textTransform: 'initial',
        letterSpacing: '0',
        willChange: 'box-shadow, transform',
        transition:
            'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        lineHeight: '1.42857143',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        touchAction: 'manipulation',
        cursor: 'pointer',
        '&:hover,&:focus': {
            boxShadow: 'none',
        },
        '& .fab,& .fas,& .far,& .fal': {
            position: 'relative',
            display: 'inline-block',
            top: '0',
            marginTop: '-1em',
            marginBottom: '-1em',
            fontSize: '1.1rem',
            marginRight: '4px',
            verticalAlign: 'middle',
        },
        '& svg': {
            position: 'relative',
            display: 'inline-block',
            top: '0',
            width: '18px',
            height: '18px',
            marginRight: '4px',
            verticalAlign: 'middle',
        },
        '&$justIcon': {
            '& .fab,& .fas,& .far,& .fal': {
                marginTop: '0px',
                marginRight: '0px',
                position: 'absolute',
                width: '100%',
                transform: 'none',
                left: '0px',
                top: '0px',
                height: '100%',
                lineHeight: '41px',
                fontSize: '20px',
            },
        },
    },
    fullWidth: {
        width: '100%',
    },
    primary: {
        backgroundColor: theme.buttons.primary.backgroundColor,
        color: theme.buttons.primary.textColor,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: theme.buttons.primary.backgroundColor,
            boxShadow: 'none',
        },
    },
    secondary: {
        color: theme.buttons.light.textColor,
        backgroundColor: theme.buttons.light.backgroundColor,
        boxShadow: 'none',
        border: `1px solid ${theme.buttons.light.borderColor}`,
        borderRight: `1px solid ${theme.buttons.light.borderColor}`,
        '&:hover,&:focus': {
            boxShadow: 'none',
            color: theme.buttons.light.textColor,
            backgroundColor: theme.buttons.light.backgroundColor,
        },
    },
    tertiary: {
        color: theme.buttons.tertiary.textColor,
        backgroundColor: theme.buttons.tertiary.backgroundColor,
        boxShadow: 'none',
        border: `1px solid ${theme.buttons.tertiary.borderColor}`,
        borderRight: `1px solid ${theme.buttons.tertiary.borderColor}`,
        '&:hover,&:focus': {
            boxShadow: 'none',
            color: theme.buttons.tertiary.textColor,
            backgroundColor: theme.buttons.tertiary.backgroundColor,
        },
    },
    info: {
        backgroundColor: infoColor,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: infoColor,
            boxShadow: 'none',
        },
    },
    success: {
        backgroundColor: successColor,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: successColor,
            boxShadow: 'none',
        },
    },
    warning: {
        backgroundColor: warningColor,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: warningColor,
            boxShadow: 'none',
        },
    },
    danger: {
        backgroundColor: dangerColor,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: dangerColor,
            boxShadow: 'none',
        },
    },
    rose: {
        backgroundColor: roseColor,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: roseColor,
            boxShadow: 'none',
        },
    },
    white: {
        '&,&:focus,&:hover': {
            backgroundColor: colors.white,
            color: grayColor,
        },
    },
    twitter: {
        backgroundColor: colors.twitterBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)',
        '&:hover,&:focus,&:visited': {
            backgroundColor: colors.twitterBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)',
        },
    },
    facebook: {
        backgroundColor: colors.facebookBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.facebookBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)',
        },
    },
    google: {
        backgroundColor: colors.googleBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.googleBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)',
        },
    },
    linkedin: {
        backgroundColor: colors.linkedinBrandColor,
        color: colors.white,
        boxShadow: 'none',
        '&:hover,&:focus': {
            backgroundColor: colors.linkedinBrandColor,
            color: colors.white,
            boxShadow: 'none',
        },
    },
    pinterest: {
        backgroundColor: colors.pinterestBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(204, 33, 39, 0.14), 0 3px 1px -2px rgba(204, 33, 39, 0.2), 0 1px 5px 0 rgba(204, 33, 39, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.pinterestBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(204, 33, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(204, 33, 39, 0.2)',
        },
    },
    youtube: {
        backgroundColor: colors.youtubeBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(229, 45, 39, 0.14), 0 3px 1px -2px rgba(229, 45, 39, 0.2), 0 1px 5px 0 rgba(229, 45, 39, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.youtubeBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(229, 45, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(229, 45, 39, 0.2)',
        },
    },
    tumblr: {
        backgroundColor: colors.tumblrBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(53, 70, 92, 0.14), 0 3px 1px -2px rgba(53, 70, 92, 0.2), 0 1px 5px 0 rgba(53, 70, 92, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.tumblrBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(53, 70, 92, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(53, 70, 92, 0.2)',
        },
    },
    github: {
        backgroundColor: colors.githubBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.githubBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)',
        },
    },
    behance: {
        backgroundColor: colors.behanceBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(23, 105, 255, 0.14), 0 3px 1px -2px rgba(23, 105, 255, 0.2), 0 1px 5px 0 rgba(23, 105, 255, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.behanceBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2)',
        },
    },
    dribbble: {
        backgroundColor: colors.dribbbleBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(234, 76, 137, 0.14), 0 3px 1px -2px rgba(234, 76, 137, 0.2), 0 1px 5px 0 rgba(234, 76, 137, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.dribbbleBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(234, 76, 137, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(234, 76, 137, 0.2)',
        },
    },
    reddit: {
        backgroundColor: colors.redditBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(255, 69, 0, 0.14), 0 3px 1px -2px rgba(255, 69, 0, 0.2), 0 1px 5px 0 rgba(255, 69, 0, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.redditBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(255, 69, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 69, 0, 0.2)',
        },
    },
    instagram: {
        backgroundColor: colors.instagramBrandColor,
        color: colors.white,
        boxShadow:
            '0 2px 2px 0 rgba(18, 86, 136, 0.14), 0 3px 1px -2px rgba(18, 86, 136, 0.2), 0 1px 5px 0 rgba(18, 86, 136, 0.12)',
        '&:hover,&:focus': {
            backgroundColor: colors.instagramBrandColor,
            color: colors.white,
            boxShadow:
                '0 14px 26px -12px rgba(18, 86, 136, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(18, 86, 136, 0.2)',
        },
    },
    cornFlowerBlue: {
        '&, &:hover, &:focus': {
            borderColor: colors.cyanCornflowerBlue,
            textColor: '#FFFFFF',
            backgroundColor: colors.cyanCornflowerBlue,
            '& > .MuiButton-label': {
                fontWeight: 400,
                fontSize: '14px',
            },
        },
    },
    cornFlowerBlueTransparent: {
        '&, &:hover, &:focus': {
            borderColor: 'transparent',
            textColor: '#FFFFFF',
            backgroundColor: 'transparent',
            '& > .MuiButton-label': {
                color: colors.cyanCornflowerBlue,
                fontWeight: 400,
                fontSize: '14px',
            },
        },
    },
    cornFlowerBlueDialog: {
        '&, &:hover, &:focus': {
            borderColor: colors.cyanCornflowerBlue,
            minWidth: '106px',
            padding: '10px 37px!important',
            textColor: '#FFFFFF',
            backgroundColor: colors.cyanCornflowerBlue,
            '& > .MuiButton-label': {
                fontWeight: 400,
                fontSize: '14px',
            },
        },
    },
    simple: {
        '&,&:focus,&:hover': {
            color: colors.white,
            background: 'transparent',
            boxShadow: 'none',
        },
        '&$primary': {
            '&,&:focus,&:hover,&:visited': {
                color: primaryColor,
            },
        },
        '&$info': {
            '&,&:focus,&:hover,&:visited': {
                color: infoColor,
            },
        },
        '&$success': {
            '&,&:focus,&:hover,&:visited': {
                color: successColor,
            },
        },
        '&$warning': {
            '&,&:focus,&:hover,&:visited': {
                color: warningColor,
            },
        },
        '&$rose': {
            '&,&:focus,&:hover,&:visited': {
                color: roseColor,
            },
        },
        '&$danger': {
            '&,&:focus,&:hover,&:visited': {
                color: dangerColor,
            },
        },
        '&$twitter': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.twitterBrandColor,
            },
        },
        '&$facebook': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.facebookBrandColor,
            },
        },
        '&$google': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.googleBrandColor,
            },
        },
        '&$linkedin': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.linkedinBrandColor,
            },
        },
        '&$pinterest': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.pinterestBrandColor,
            },
        },
        '&$youtube': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.youtubeBrandColor,
            },
        },
        '&$tumblr': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.tumblrBrandColor,
            },
        },
        '&$github': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.githubBrandColor,
            },
        },
        '&$behance': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.behanceBrandColor,
            },
        },
        '&$dribbble': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.dribbbleBrandColor,
            },
        },
        '&$reddit': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.redditBrandColor,
            },
        },
        '&$instagram': {
            '&,&:focus,&:hover,&:visited': {
                color: colors.instagramBrandColor,
            },
        },
    },
    transparent: {
        '&,&:focus,&:hover': {
            color: 'inherit',
            background: 'transparent',
            boxShadow: 'none',
        },
    },
    disabled: {
        opacity: '0.65',
        pointerEvents: 'none',
        '&:active, &:focus, &:hover': {
            color: colors.friarGray,
        },
        '&$secondary': {
            border: `1px solid ${colors.silver}`,
            color: colors.friarGray,
        },
    },
    lg: {
        padding: '1.125rem 2.25rem',
        fontSize: '0.875rem',
        lineHeight: '1.333333',
        borderRadius: '0.2rem',
    },
    md: {
        padding: '4px 19px',
        fontSize: 14,
        lineHeight: 1.43,
    },
    sm: {
        padding: '0.40625rem 1.25rem',
        fontSize: '0.6875rem',
        lineHeight: '1.5',
        borderRadius: '0.2rem',
    },
    round: {
        borderRadius: '30px',
    },
    block: {
        width: '100% !important',
    },
    link: {
        '&,&:hover,&:focus': {
            backgroundColor: 'transparent',
            color: theme?.links?.primary?.textColor || linkPrimaryColor,
            boxShadow: 'none',
        },
    },
    justIcon: {
        paddingLeft: '12px',
        paddingRight: '12px',
        fontSize: '20px',
        height: '41px',
        minWidth: '41px',
        width: '41px',
        '& .fab,& .fas,& .far,& .fal,& svg': {
            marginRight: '0px',
        },
        '&$lg': {
            height: '57px',
            minWidth: '57px',
            width: '57px',
            lineHeight: '56px',
            '& .fab,& .fas,& .far,& .fal': {
                fontSize: '32px',
                lineHeight: '56px',
            },
            '& svg': {
                width: '32px',
                height: '32px',
            },
        },
        '&$sm': {
            height: '30px',
            minWidth: '30px',
            width: '30px',
            '& .fab,& .fas,& .far,& .fal': {
                fontSize: '17px',
                lineHeight: '29px',
            },
            '& svg': {
                width: '17px',
                height: '17px',
            },
        },
    },
    fileButton: {},
}));
